export default {
	addresses: 'العناوين',
	'contact-information': 'معلومات التواصل',
	'contact-info': 'معلومات التواصل',

	contactInfoTypes: {
		phone: 'موبايل',
		landline: 'هاتف أرضي',
		email: 'بريد إلكتروني',
		facebook: 'فيسبوك',
		twitter: 'إكس (تويتر)',
		whatsApp: 'واتساب',
		telegram: 'تيليغرام',
		linkedIn: 'لينكد إن',
		website: 'موقع',
	},

	'creation-customer-request': 'طلب إضافة عميل',
	'modification-customer-request': 'طلب تعديل عميل',
	'deletion-customer-request': 'طلب حذف عميل',

	'the-request-is-sent': 'تم إرسال الطلب',

	'no-customers-to-show': 'لا يوجد عملاء للعرض',

	'no-customer-types-to-add': 'لا يمكن إضافة عميل، لا يوجد أنواع عملاء متاحة',

	'add-location': 'إضافة موقع',
}